angular.module('qkr')
    .controller('menuController', (options, $scope, $routeParams, departmentService,
                                   menuService, FormHelper, $uibModal, utils, formBuilderService, gettextCatalog,
                                   appConfig, pushNotificationService, $q, menuId, departmentId, messageService,
                                   merchantService) => {
    const vm = $scope;

    // TODO - ensure all of this state is used on the template - remove state if it is pointless

    vm.filtered = [];
    vm.menuItems = [];
    vm.pushNotificationAvailabilityList = [];
    vm.menuItemsLoaded = false;
    vm.categories = [];
    vm.selectedCategoryId = -1;

    vm.baseImgUrl = null;
    vm.orderProp = 'dateCreated';
    vm.optionSets = [];
    vm.currentMenu = null;
    vm.allowSorting = true;
    vm.menuViewReadonly = false;
    vm.showAddProductButton = true;
    vm.allowedCustomizeMenuItems = true;
    vm.allowedCreateMenuItems = true;

    const formHelper = new FormHelper($scope);

    vm.init = function() {
        vm.showAddProductButton = merchantService.behaviour(merchantService.merchantInfo, 'menu.showAddProductButton');
        vm.menuViewReadonly = options.menuViewReadonly;
        vm.allowedCustomizeMenuItems = options.allowedCustomizeMenuItems;
        vm.allowedCreateMenuItems = options.allowedCreateMenuItems;

        // TODO extract out to resolve, should not fetch data in the init. Mess.

        if (menuId !== null) {
            menuService.setSelectedMenuId(menuId);
        }


        if (departmentId !== null) {
            departmentService.setSelectedDepartmentId(departmentId);

            menuService.loadMenus(departmentId)
                .then(() => {
                    vm.currentMenu = menuService.getCurrentMenu();

                    // Iterate through the list and mark items that are invalid and
                    // Require user intervention
                    if (!utils.hasNoValue(vm.menuItems)) {
                        vm.markInvalidMenuItems();
                    }
                });

        } else if (menuId !== null) {
            menuService.setCurrentMenuId(menuId);

            menuService.loadSharedMenus()
                .then(() => {
                    vm.currentMenu = menuService.getCurrentMenu();
                });
        }

        formBuilderService.listTemplates().then((promise) => {
            vm.permissionTemplateList = promise.data;
        });

        // TODO Do not reload in the init, are we nuts or what
        vm.reload();
        vm.allowSorting = !((vm.selectedCategoryId === -1 || !utils.hasNoValue(vm.query)));
    };

    // Manually filter the list based on the category and search query
    vm.doFilterOnCategory = function() {
        const out = [];
        const searchtext = utils.hasNoValue(vm.query) ? '' : ('' + vm.query).toLowerCase();
        vm.allowSorting = !((vm.selectedCategoryId === -1 || !utils.hasNoValue(vm.query)));

        for (let a = 0; a < vm.menuItems.length; a++) {
            if (vm.selectedCategoryId === -1 || (!utils.hasNoValue(vm.menuItems[a].category)
                    && (vm.menuItems[a].category.id == vm.selectedCategoryId))) {
                if (('' + vm.menuItems[a].name).toLowerCase().indexOf(searchtext) > -1) {
                    out.push(vm.menuItems[a]);
                }
            }
        }
        
        vm.filtered = out;
    };

    // TODO remove from vm, not called from template
    // Load the menu again
    vm.reloadMenuItems = function() {
        const departmentId = departmentService.getCurrentDepId();
        const menuId = menuService.getCurrentMenuId();

        const pushNotificationAvailabilityPromise = pushNotificationService
            .getProductPushNotificationAvailabilityListForMenu(departmentId, menuId);

        const menuItemsPromise = menuService.loadMenuItems();

        $q.all([menuItemsPromise, pushNotificationAvailabilityPromise]).then((promises) => {
            const menuItems = promises[0];
            const pushNotificationAvailabilityList = promises[1];

            vm.setupMenuItems(menuItems, pushNotificationAvailabilityList);
            vm.menuItemsLoaded = true;
        });
    };

    // Load the categories applicable for this menu
    vm.reloadProductCategories = function() {
        menuService.loadProductCategoriesForMenu().then((promise) => {
            const allcats = promise;
            const noempty = [];
            // Server returns categories with no items after deleting items
            // So we manually strip them here
            let selectedCategoryExists = false;
            for (let i = 0; i < allcats.length; i++) {
                if (allcats[i].numItems !== 0) {
                    noempty.push(allcats[i]);
                    if (vm.selectedCategoryId == allcats[i].id) {
                        selectedCategoryExists = true;
                    }
                } 
            }
            vm.categories = noempty;
            
            if (!selectedCategoryExists) {
                vm.selectedCategoryId = -1;
            }
            
            if (vm.selectedCategoryId === -1 && !utils.hasNoValue(vm.categories)) {
                vm.doFilterOnCategory();
            }
        });
    };

    vm.reload = function() {
        vm.reloadMenuItems();
        vm.reloadProductCategories();
    };

    // Prevent re-ordering of products
    vm.startProductOrder = function(evt, ui) {
        if (vm.selectedCategoryId === -1 || !utils.hasNoValue(vm.query)) {
            ui.item.sortable.cancel();
        }
    };

    vm.updateProductOrder = function(evt, ui) {
        try {
            if (vm.selectedCategoryId === -1 || !utils.hasNoValue(vm.query)) {
                ui.item.sortable.cancel();
            } else {
                // QKRD-733 - Menu items getting duplicated during sorting.
                vm.menuItemsLoaded = false;

                const itemIndex = ui.item.sortable.index;
                const replaceIndex = ui.item.sortable.dropindex;
                const itemBeingMoved = vm.filtered[itemIndex];
                const itemBeingReplaced = vm.filtered[replaceIndex];
                const updatedItem = angular.copy(itemBeingMoved);
                updatedItem.prodOrder = itemBeingReplaced.prodOrder;
                menuService.updateMenuItemPosition(updatedItem).then(() => {
                    vm.reloadMenuItems();
                });
            }
        } catch (e) {}
    };

    // Update the order of categories
    vm.updateCategoryOrder = function(evt, ui) {
        try {
            const itemIndex = ui.item.sortable.index;
            const replaceIndex = ui.item.sortable.dropindex;
            const itemBeingMoved = vm.categories[itemIndex];

            menuService.updateCategoryPosition(vm.currentMenu, itemBeingMoved, replaceIndex).then(() => {
                vm.reloadProductCategories();
            });
        } catch (e) {

        }
    };

    // Dynamically style the indicator color (not used)
    vm.styleIndicator = function(value) {
        const col = value.id == vm.selectedCategoryId ? 'FFF' : value.colour;
        return {'background-color': '#' + col};
    };

    // Dynamically style the row color (not used)
    vm.styleRow = function(value) {
        const col = value.colour;
        return {'background-color': '#' + col};
    };

    // The user selects a category
    vm.selectCategory = function(selCategory) {
        vm.selectedCategoryId = selCategory;
        vm.doFilterOnCategory();
    };

    vm.removeMenuItem = function(menuItem) {
        const confMsg = gettextCatalog.getString('Are you sure you want to delete this item? It will be removed only ' +
            'from this menu');

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Delete Item from Menu');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then(result => {
            if (result === 'ok') {
                menuService.removeMenuItem(menuItem).then(() => {
                    vm.menuItems = [];
                    vm.menuItemsLoaded = false;
                    vm.reload();
                }, () => {
                    vm.menuItems = [];
                    vm.menuItemsLoaded = false;
                    vm.reload();
                });
            }
        });
    };

    // TODO remove from vm, this is not used from template
    // Handle response from attempted save
    vm.saveMenuCallback = function(response) {
        const r = formHelper.handleResponse(response);
        if (r.isSuccess()) {
           vm.reload();

           messageService.saveAlert();
        }
    };

    // TODO remove from vm, this is not used from template
    vm.updateSelectedProduct = function(selectedProduct) {
        menuService.updateMenuItem(selectedProduct).then((promise) => {
            vm.saveMenuCallback(promise);
        }, (promise) => {
            vm.saveMenuCallback(promise);
        });
    };

    vm.hideOrUnhideMenuItem = function(menuItem) {
    	if (!menuItem.offline) {
	    	menuService.hideMenuItem(menuItem).then(() => {
	            vm.menuItems = [];
	            vm.menuItemsLoaded = false;
	            vm.reload();
	        }, () => {
	            vm.menuItems = [];
	            vm.menuItemsLoaded = false;
	            vm.reload();
	        });
    	} else {
    		menuService.unhideMenuItem(menuItem).then(() => {
	            vm.menuItems = [];
	            vm.menuItemsLoaded = false;
	            vm.reload();
	        }, () => {
	            vm.menuItems = [];
	            vm.menuItemsLoaded = false;
	            vm.reload();
	        });
    	}
    };

    // TODO remove these listeners
    // The product list needs to be reloaded
    vm.$on('reloadMenuItems', (evt, newItems) => {
        vm.reloadMenuItems();
    });

    // The product list has been reloaded
    vm.$on('newMenus', (evt, args) => {
        if ($routeParams.departmentId != null) {
            menuService.loadMenus($routeParams.departmentId).then(() => {
                vm.currentMenu = menuService.getCurrentMenu();
            });
        }
    });

    // TODO not called from template, remove from vm
    vm.setupMenuItems = function(newItemList, pushNotificationAvailabilityList) {
        newItemList.forEach(menuItem => {
            const pushNotificationAvailability = findPushNotificationAvailabilityForMenuItem(pushNotificationAvailabilityList, menuItem);
            menuItem.pushNotificationAvailability = pushNotificationAvailability;
        });

        vm.menuItems = newItemList;
        if (!utils.hasNoValue(vm.currentMenu)) {
            vm.markInvalidMenuItems();
        }

        vm.doFilterOnCategory();
    };

    // TODO not called from template, remove from vm
    vm.markInvalidMenuItems = function() {
        if (utils.getMenuType(vm.currentMenu) === 'fixed') {
            vm.menuItems.forEach(prod => {
                prod.requiresAvailabilityInfo = utils.fixedMenuItemHasMissingAvailability(vm.currentMenu, prod);
            });
        }
    };
    // Add a Product to an existing menu - brings up a modal showing existing
    // Products
    vm.addProductModal = function() {
        const modalInstance = $uibModal.open({
            template: require('../templates/menuitem/addProductFromInventory.html'),
            controller: 'AddProductFromInventoryController',
            windowClass: 'fade modal-huge',
            backdrop: 'static',
            resolve: {
                currentCategoryId() {
                    return vm.selectedCategoryId;
                },
                allowedCreateMenuItems() {
                    return vm.allowedCreateMenuItems;
                },
                menuItems() {
                    return menuService.loadMenuItems();
                }
            }
        });

        modalInstance.result.then((res) => {
            if (res !== 'cancel') {
                vm.reload();
                vm.selectedCategoryId = -1;
            }
        });
    };

    // TODO remove from vm, not called from template
    // Edit the settings for this menu
    vm.editMenuSettings = function() {
        menuService.loadMenu(vm.currentMenu.id).then(promise => {
            vm.currentMenu = promise;

            const modalInstance = $uibModal.open({
                template: require('../templates/menu/editMenu.html'),
                controller: 'MenuEditController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    menu() {
                        return vm.currentMenu;
                    },
                    isNewMenu() {
                        return false;
                    },
                    isSharedMenu() {
                        return false;
                    },
                    existingMenuTypes() {
                        return [];
                    }

                }
            });

            modalInstance.result.then(res => {
            });
        });
    };

    // Edit an existing product
    // Copies and shows modal
    vm.editMenuItem = function(p) {
        if (!vm.allowedCustomizeMenuItems || vm.menuViewReadonly) {
            return;
        }
        const modalInstance = $uibModal.open({
            template: require('../templates/menuitem/editMenuItem.html'),
            controller: 'MenuItemEditController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                prod() {
                	return menuService.getMenuItem(p.id).then((menuItem) => menuItem);
                },
                menu() {
                    return vm.currentMenu;
                },
                permissionTemplateList() {
                    return vm.permissionTemplateList;
                },
                isNewProduct() {
                    return false;
                },
                pushNotificationContext() {
                    const departmentId = departmentService.getCurrentDepId();
                    const menuId = menuService.getCurrentMenuId();

                    return pushNotificationService.getPushNotificationContextForMenuItem(departmentId, menuId, p.id)
                        .then((pushNotificationContext) => pushNotificationContext,
                              (reason) => console.error(reason));
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
            vm.selected = selectedItem;
        });
    };

    vm.onCategorySortHandleKeydown = function(evt, category){
        const keyCodes = {
            ESC: 27,
            UP: 38,
            DOWN: 40,
        };

        if([keyCodes.UP, keyCodes.DOWN].includes(evt.keyCode)){
            evt.preventDefault();

            const currentIndex = category ?
                vm.categories.findIndex((c) => c.id === category.id) :
                -1;

            const replaceIndex = evt.keyCode === keyCodes.UP ?
                currentIndex-1 : currentIndex+1;

            if(replaceIndex >= 0 && replaceIndex < vm.categories.length){
                menuService.updateCategoryPosition(vm.currentMenu, category,
                    replaceIndex).then(() => {
                    vm.reloadProductCategories();
                });
            }
        }else if(evt.keyCode === keyCodes.ESC && evt.target){
            //remove the focus on escape
            evt.target.blur();
        }
    }

    function findPushNotificationAvailabilityForMenuItem(pushNotificationAvailabilityList, menuItem) {
        for (let i = 0; i < pushNotificationAvailabilityList.length; i++) {
            const pushNotificationAvailability = pushNotificationAvailabilityList[i];
            if (pushNotificationAvailability.menuItemId === menuItem.id) {
                return pushNotificationAvailability;
            }
        }
        return null;
    }
});



// WEBPACK FOOTER //
// ./src/controllers/menu.controller.js